module.exports = __webpack_public_path__ + "static/media/Forest_Edited_Caroussel.53c2ca1d.jpg";